<template>
  <div id="app" class="d-flex flex-column h-100">
    <nav class="navbar navbar-dark navbar-expand-md">
      <div class="container-fluid container-custom nav-header">
        <router-link class="navbar-brand pl-3" :to="{ name: 'home' }" exact>SHOW<span class="color">BAG</span></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbar">
          <div class="navbar-text ml-auto mr-auto col-12 col-sm-6">
            <h1 class="float-md-right">Чехлы и кофры<br>для музыкальных инструментов</h1>
          </div>
          <div class="navbar-text contacts pr-4 col-12 col-sm-6">
            <div class="float-sm-right">
              <span>г. Новосибирск, ул. Тюменская, 14</span><br>
              <span>+7 (913) 927-60-24</span><br>
              <span><a href="mailto:showbags@yandex.ru">showbags@yandex.ru</a></span><br>
              <span><a href="https://vk.com/kofr_music">vk.com/kofr_music</a></span>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="container-fluid container-custom">
      <router-view/>
    </div>
    <div class="mt-3"></div>
    <footer class="footer mt-auto row text-center m-0 py-3">
      <div class="container-fluid container-custom">
        <div class="contacts col-12 py-3 text-left">
          <span>г. Новосибирск, ул. Тюменская, 14</span><br>
          <span>+7 (913) 927-60-24</span><br>
          <span><a href="mailto:showbags@yandex.ru">showbags@yandex.ru</a></span><br>
          <span><a href="https://vk.com/kofr_music">vk.com/kofr_music</a></span><br>
          <span><a v-if="!isLoggedIn" href="#" data-toggle="modal" data-target="#loginModal" class="admin float-right">Администрирование</a></span>
          <span><a v-if="isLoggedIn" href="#" class="admin float-right" @click="logout()">Выйти</a></span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  created() {
    if (document.cookie) {
      axios.get('auth/check')
        .then((resp) => this.$store.dispatch('login', resp))
        .catch(() => this.$store.dispatch('logout'));
    }
    window.addEventListener('resize', this.$store.commit('setWindowWidth'));
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn();
    },
  },
  methods: {
    logout() {
      axios.post('auth/logout').then(() => {
        this.$store.dispatch('logout');
      });
    },
  },
}
</script>

<style lang="scss">
// MAIN
:root {
  --dark: #1d1e22;
  --light: #f0f0f0;
  --darklight: #393f4d;
  --color: #feda6a;
}
* {
  margin: 0;
  padding: 0;
  outline: none !important;
}
html, body {
  background-color: #f0f0f0;
  color: var(--dark);
}

// IDS
#app {
  // font-family: 'Roboto Condensed', sans-serif;
  font-family: 'Oswald', sans-serif;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#canvas {
  width: 100%;
  height: 500px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='180px' width='180px'><text transform='translate(20, 100) rotate(-25)' fill='rgba(1, 1, 1, 0.1)' font-size='19'>vk.com/kofr_music</text></svg>");
}

// TAGS
button, textarea {
  border-radius: 0px !important;
  box-shadow: none !important;
}
select {
  border-radius: 0px !important;
  padding: 0px 10px;
}
input {
  height: 24px;
  border-radius: 0 !important;
  box-shadow: none !important;
}
i:hover {
  cursor: pointer;
}
h2, h3 {
  text-transform: uppercase;
  text-align: center;
}
h2 i {
  padding: .7rem 20px;
}
h4 {
  text-transform: uppercase;
}
label {
  line-height: 1.4;
  margin-bottom: 0;
  text-align: left;
}
label img {
  opacity: 0.8;
  margin: -1px;
}
label, input, select, .check-icon {
  height: 30px;
  line-height: 30px;
  box-shadow: none !important;
  &:focus {
    outline: none !important;
  }
}
nav {
  font-family: 'Oswald', sans-serif;
  font-weight: 300;
  background-color: var(--darklight);
  color: var(--light) !important;
  background: grey url('/header.png');
  background-blend-mode: multiply;
  background-size: cover;
  background-position: center;
  a {
    color: white;
    &:hover {
      color: var(--light);
    }
  }
  .navbar-brand {
    font-size: 48px;
    font-weight: 600;
  }
  .navbar-text {
    h1 {
      font-weight: 300;
      font-size: 24px;
      color: white;
      text-transform: uppercase;
    }
  }
  .color {
    color: var(--color);
  }
}

// CLASSES
.container {
  margin-top: 10px;
}
.contacts {
  font-size: 14px;
  color: var(--light);
}
.footer {
  background-color: var(--darklight);
  color: var(--light);
}
.footer a {
  color: #fff;
}
.footer .admin {
  color: var(--dark);
}
.no-border {
  border: 0;
  box-shadow: none;
}
.cursor-pointer {
  cursor: pointer;
}
.block-header {
  background-color: var(--color);
  color: var(--dark);
  font-size: 20px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
.nav-header {
  min-height: 80px;
}
#navbar.show {
  min-height: 110px;
}
.container-custom {
  max-width: 1400px;
}
.btn-outline-primary {
  border-color: var(--darklight);
  background-color: var(--light);
  color: var(--dark);
  box-shadow: none !important;
  border-radius: 0px;
  &:hover, &:active {
    background-color: var(--darklight) !important;
    border-color: var(--darklight) !important;
    color: var(--light) !important;
  }
}
.form-row {
  text-transform: uppercase;
  color: var(--dark);
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-right: 0px;
  margin-left: 0px;
  transition: all .15s ease-in-out;
  &:hover, &.active {
    text-decoration: none;
    background-color: var(--darklight);
    color: var(--light);
    transition: all .15s ease-in-out;
  }
}
.item {
  text-transform: initial !important;
}
.arrow-blank {
  padding-left: 28px;
}
.material-icons {
  line-height: 50px;
}
.checkbox {
  line-height: 30px;
  height: 30px;
  margin-right: -1px;
}
.filepond--wrapper {
  border: 1px dashed var(--darklight);
  cursor: pointer;
}
.filepond--drop-label.filepond--drop-label label {
  cursor: pointer;
}
.reset {
  position: relative;
  top: -500px;
  float: right;
  height: 1px;
}
.rotate, .top-open {
  position: relative;
  top: -500px;
  float: right;
  height: 1px;
  i {
    width: 50px;
    font-size: 25px;
    text-align: center;
    transition: all .15s ease-in-out;
    &:hover, &.active {
      background-color: var(--darklight);
      color: var(--light);
      fill: var(--light);
      transition: all .15s ease-in-out;
    }
  }
  span {
    padding: 12px;
    width: 50px;
    font-size: 25px;
    text-align: center;
    transition: all .15s ease-in-out;
    cursor: pointer;
    &:hover, &.active {
      background-color: var(--darklight);
      color: var(--light);
      fill: var(--light);
      transition: all .15s ease-in-out;
    }
  }
}
.sizes {
  position: relative;
  top: -500px;
  float: left;
  height: 1px;
  width: 120px;
}
.open-label {
  margin-top: 12px;
}
.color-input {
  border: 1px solid #bbb;
  padding: 0px;
  height: 24px;
  width: 40px !important;
  width: 100%;
  cursor: pointer;
}
.form-control:focus {
  border-color: var(--darklight);
}
.btn-custom {
  height: 30px;
  line-height: 30px;
  width: 30px;
  border-radius: 0px;
  box-shadow: none;
}
.sub {
  position: absolute;
  border-left: 1px solid #2c3e50;
  height: 12px;
  width: 5px;
  border-bottom: 1px solid #2c3e50;
  left: 15px;
}
.alert {
  border-radius: 0px;
}
.pageWrapper {
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
  width: 21cm;
  height: 29.7cm;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
}
.page {
  background: white;
  display: block;
  width: 21cm;
  height: 29.7cm;
}
.info {
  height: 70px;
  max-height: 70px;
  overflow: hidden;
}
.info-grips {
  height: 30px;
  max-height: 30px;
  overflow: hidden;
}
tr.active {
  background-color: rgba(0,0,0,0.1);
}
.h-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px !important;
}
</style>
